import {Injectable} from '@angular/core';
import {NgxCsvParser} from 'ngx-csv-parser';
import {Observable, of, tap} from 'rxjs';
import {catchError, map, take} from 'rxjs/operators';
import {CsvParserData} from '../models/io/csvParserData';

@Injectable()
export class CsvParserService {
  constructor(private _ngxCsvParser: NgxCsvParser) {  }

  parse(file: File): Observable<CsvParserData> {
    if (!file.name.endsWith('.csv')) {
      const data = new CsvParserData();
      data.error = ['Bitte nur .csv Dateien verwenden'];
      return of(data);
    }
    return this._ngxCsvParser.parse(file, { header: false, delimiter: ';', encoding: 'iso-8859-2' }).pipe(
      take(1),
      tap(_ => console.log),
      map((result: any[]) => {
        const data = new CsvParserData();
        data.result = result;
        return data;
      }),
      catchError(err => {
        console.log(err);
        const data = new CsvParserData();
        data.error = [err];
        return of(data);
      }));
  }
}
